/* JawZen Cart Drawer */
(function(){
  'use strict';

  // ---- Free gift variant IDs + display data ----
  var FREE_GIFTS = [
    { id: 54208498205038, retail: 4999, label: 'Handheld TMJ Massager' },
    { id: 54208507806062, retail: 2999, label: 'JawZen Carrying Case' },
    { id: 54208508035438, retail: 1999, label: 'TMJ Relief Guide (PDF)' }
  ];
  var FREE_IDS = FREE_GIFTS.map(function(g){ return g.id; });

  // Retail compare price for main product — shown crossed out in drawer
  var WEARABLE_RETAIL_CENTS = 37999; // $379.99

  function fmt(cents){ return '$' + (cents / 100).toFixed(2); }

  // ---- State ----
  var currentCart = null;

  // ---- Drawer elements ----
  var overlay, panel, body, countEl, subtotalEl, savingsEl, promoFill;

  function getEls(){
    overlay   = document.getElementById('jzd-overlay');
    panel     = document.getElementById('jzd-panel');
    body      = document.getElementById('jzd-body');
    countEl   = document.getElementById('jzd-count');
    subtotalEl= document.getElementById('jzd-subtotal');
    savingsEl = document.getElementById('jzd-savings');
    promoFill = document.getElementById('jzd-promo-fill');
  }

  function open(){
    if (!overlay) getEls();
    overlay.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function close(){
    overlay.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---- Fetch & render cart ----
  function refreshCart(){
    if (!body) return;
    body.innerHTML = '<div class="jzd-spinner"></div>';
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(renderCart)
      .catch(function(){ body.innerHTML = '<div class="jzd-empty"><span class="jzd-empty-icon">🛒</span><span class="jzd-empty-text">Couldn\'t load cart</span></div>'; });
  }

  function renderCart(cart){
    if (!body) return;
    currentCart = cart;

    var mainItems = cart.items.filter(function(i){ return FREE_IDS.indexOf(i.variant_id) === -1; });
    var giftItems = cart.items.filter(function(i){ return FREE_IDS.indexOf(i.variant_id) !== -1; });
    var totalItems = mainItems.reduce(function(s,i){ return s + i.quantity; }, 0);

    // Update count badge
    if (countEl) countEl.textContent = totalItems > 0 ? '(' + totalItems + ')' : '';

    if (cart.item_count === 0){
      body.innerHTML = '<div class="jzd-empty"><span class="jzd-empty-icon">🛒</span><span class="jzd-empty-text">Your cart is empty</span><span class="jzd-empty-sub">Add JawZen to get started</span></div>';
      if (subtotalEl) subtotalEl.textContent = '$0.00';
      return;
    }

    // Free shipping progress
    var FREE_SHIP_THRESHOLD = 0; // already free for JawZen at $249
    var mainSubtotal = mainItems.reduce(function(s,i){ return s + i.line_price; }, 0);
    if (promoFill) promoFill.style.width = '100%';

    // Savings: compare_at_price (with hardcoded fallback) minus actual price
    var savings = 0;
    mainItems.forEach(function(item){
      var retail = (item.compare_at_price && item.compare_at_price > item.price)
        ? item.compare_at_price
        : WEARABLE_RETAIL_CENTS;
      savings += (retail - item.price) * item.quantity;
    });
    // Add retail value of free gifts as savings
    FREE_GIFTS.forEach(function(g){
      var inCart = giftItems.find(function(i){ return i.variant_id === g.id; });
      if (inCart) savings += g.retail;
    });
    // Free shipping savings
    if (mainItems.length > 0) savings += 995; // $9.95

    var html = '<div class="jzd-items">';

    // Main items
    mainItems.forEach(function(item){
      var retailCents = (item.compare_at_price && item.compare_at_price > item.price)
        ? item.compare_at_price
        : WEARABLE_RETAIL_CENTS;
      var compareStr = '<span style="color:var(--jzd-faint);text-decoration:line-through;font-weight:400;font-size:13px;margin-right:4px">' + fmt(retailCents * item.quantity) + '</span>';
      html += '<div class="jzd-item">'
        + '<img class="jzd-item-img" src="' + item.image + '" alt="' + escAttr(item.title) + '" loading="lazy">'
        + '<div class="jzd-item-body">'
          + '<div class="jzd-item-name">' + esc(item.product_title) + '</div>'
          + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="jzd-item-variant">' + esc(item.variant_title) + '</div>' : '')
          + '<div class="jzd-qty-row">'
            + '<div class="jzd-qty">'
              + '<button class="jzd-qty-btn" data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>'
              + '<span class="jzd-qty-num">' + item.quantity + '</span>'
              + '<button class="jzd-qty-btn" data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>'
            + '</div>'
            + '<div style="display:flex;align-items:baseline;gap:4px">'
              + compareStr
              + '<span class="jzd-item-price">' + fmt(item.line_price) + '</span>'
            + '</div>'
          + '</div>'
          + '<button class="jzd-remove" data-key="' + item.key + '">Remove</button>'
        + '</div>'
      + '</div>';
    });

    // Free gifts divider + items
    if (giftItems.length > 0){
      html += '<div class="jzd-gifts-label">🎁 Your Free Gifts (' + giftItems.length + ' included)</div>';
      giftItems.forEach(function(item){
        var giftMeta = FREE_GIFTS.find(function(g){ return g.id === item.variant_id; });
        var retail = giftMeta ? giftMeta.retail : 0;
        html += '<div class="jzd-item">'
          + '<img class="jzd-item-img" src="' + item.image + '" alt="' + escAttr(item.title) + '" loading="lazy">'
          + '<div class="jzd-item-body">'
            + '<div class="jzd-item-name">' + esc(item.product_title) + '</div>'
            + '<div class="jzd-gift-row">'
              + '<span class="jzd-gift-badge">Free Gift</span>'
              + (retail ? '<span class="jzd-gift-retail">' + fmt(retail) + '</span>' : '')
              + '<span class="jzd-gift-free">FREE</span>'
            + '</div>'
          + '</div>'
        + '</div>';
      });
    }

    html += '</div>';
    body.innerHTML = html;

    // Totals
    if (subtotalEl) subtotalEl.textContent = fmt(mainSubtotal);
    if (savingsEl && savings > 0){
      savingsEl.style.display = '';
      savingsEl.textContent = 'You\'re saving ' + fmt(savings) + ' on this order 🎉';
    } else if (savingsEl){
      savingsEl.style.display = 'none';
    }

    // Bind qty + remove buttons
    body.querySelectorAll('.jzd-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta);
        var item = cart.items.find(function(i){ return i.key === key; });
        if (!item) return;
        updateQty(key, item.quantity + delta);
      });
    });
    body.querySelectorAll('.jzd-remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        updateQty(btn.dataset.key, 0);
      });
    });
  }

  function updateQty(key, qty){
    if (!body) return;

    var updates = {};
    updates[key] = qty;

    // Whenever a main item's quantity changes, sync all gift quantities to the
    // new total wearable quantity. This handles: removal (→0), decrease (2→1),
    // and increase (1→2) — keeping gifts permanently locked to wearable count.
    if (currentCart) {
      var changedItem = currentCart.items.find(function(i){ return i.key === key; });
      var isMainItem = changedItem && FREE_IDS.indexOf(changedItem.variant_id) === -1;
      if (isMainItem) {
        // Sum all main item quantities after the proposed change
        var newWearableQty = currentCart.items.reduce(function(total, item){
          if (FREE_IDS.indexOf(item.variant_id) !== -1) return total;
          return total + (item.key === key ? qty : item.quantity);
        }, 0);
        // Set every gift to match
        currentCart.items.forEach(function(item){
          if (FREE_IDS.indexOf(item.variant_id) !== -1) updates[item.key] = newWearableQty;
        });
      }
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      renderCart(cart);
      updateNavCount(cart.item_count);
    });
  }

  function updateNavCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count > 0 ? count : '';
    });
  }

  // ---- Shared add-to-cart + open logic ----
  function addItemsAndOpen(mainVariantId, qty, triggerEl) {
    var origText = triggerEl ? triggerEl.textContent : '';
    if (triggerEl){ triggerEl.disabled = true; triggerEl.textContent = 'Adding…'; }

    var items = [{ id: mainVariantId, quantity: qty }];
    FREE_GIFTS.forEach(function(g){ items.push({ id: g.id, quantity: 1 }); });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r){ return r.json(); })
    .then(function(result){
      if (triggerEl){ triggerEl.disabled = false; triggerEl.textContent = origText; }
      if (result.status){ console.warn('Cart add error:', result.description); return; }
      if (window.fbq){ try { fbq('track', 'AddToCart'); } catch(ex){} }
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        updateNavCount(cart.item_count);
        open();
      });
    })
    .catch(function(){
      if (triggerEl){ triggerEl.disabled = false; triggerEl.textContent = origText; }
    });
  }

  // ---- ATC intercept: product forms ----
  function setupAtc(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !/\/cart\/add/.test(form.action)) return;
      e.preventDefault();
      e.stopPropagation(); // prevent jawzen-app.js form handler from also firing

      var submitBtn = form.querySelector('[type="submit"]');
      var formData = new FormData(form);
      var variantId = parseInt(formData.get('id'));
      var qty = parseInt(formData.get('quantity') || '1');
      if (!variantId) return;

      addItemsAndOpen(variantId, qty, submitBtn);
    }, true); // capture phase — fires before any element-level handlers

    // ---- ATC intercept: direct /cart/VARIANT:QTY links (sticky bar, final CTA) ----
    document.addEventListener('click', function(e){
      var el = e.target.closest('a[href]');
      if (!el) return;
      var href = el.getAttribute('href') || '';
      var match = href.match(/^\/cart\/(\d+):(\d+)/);
      if (!match) return;
      e.preventDefault();
      var variantId = parseInt(match[1]);
      var qty = parseInt(match[2]);
      addItemsAndOpen(variantId, qty, el);
    });
  }

  // ---- Init ----
  function init(){
    getEls();
    if (!overlay || !panel) return; // drawer HTML not on this page

    // Close triggers
    overlay.addEventListener('click', close);
    var closeBtn = document.getElementById('jzd-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

    // Open trigger for nav cart icon
    document.querySelectorAll('[data-open-cart]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });

    setupAtc();

    // Load count badge immediately on page load
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      updateNavCount(cart.item_count);
    }).catch(function(){});
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Utility
  function esc(s){ var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function escAttr(s){ return (s || '').replace(/"/g,'&quot;'); }

})();
